import React from 'react'

export default function SubmittalPdf(props) {
  return (
    <div align="center">
      <h2>404 - this is not a valid link :(</h2>
    </div>
  )
}